"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
var _exportNames = {
  ModelSelector: true
};
exports.ModelSelector = void 0;

var _modelSelector = _interopRequireDefault(require("./components/model-selector"));

exports.ModelSelector = _modelSelector["default"];

var _modelSelector2 = require("./components/model-selector.default-props");

Object.keys(_modelSelector2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _modelSelector2[key]) return;
  exports[key] = _modelSelector2[key];
});